/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isEmptyData } from '../../../../utils/helper';
import { LoaderIcon } from '../../../../utils/svg';
import { getCategory, setCategory } from '../../../../store/reducers/product';
import { useParams } from 'react-router-dom';

const Tags = () => {
	const dispatch = useDispatch();
	const { type } = useParams(); 
	const { details: outlet, loading: isLoadingOutlet } = useSelector((store) => store?.outlet);
	const { categories, loading: isLoadingCategory, selectedCategory } = useSelector((state) => state.product);

	const handleSelect = (value) => {
		dispatch(setCategory({ selectedCategory: value }));
	};

	const handleGetCategory = () => {
		dispatch(
			getCategory({
				storeID: outlet?.storeID,
				availability: type,
			}),
		);
		dispatch(
			setCategory({
				selectedCategory: "all",
			}),
		);
	};

	useEffect(() => {
		if (!outlet?.storeID || isLoadingOutlet) return;
		handleGetCategory();
	}, [outlet?.storeID, type]);

	return (
		<div className={`w-full mb-3 ${isEmptyData(categories) && !isLoadingCategory && ''}`}>
			{isLoadingCategory ? (
				<div className='w-full h-10 flex justify-center items-center'>
					<LoaderIcon />
				</div>
			) : (
				<div className='grid grid-flow-col auto-cols-max overflow-x-auto snap-x snap-mandatory scroll-smooth scroll-px-4 gap-2 scrollbar-hide'>
					{categories?.map((category, index) => {
						return (
							<div
								key={`category-${index}`}
								className={`snap-start cursor-pointer rounded-full bg-gray-100 px-3 py-1.5 text-gray-500 ${selectedCategory === category?.catSlug && '!bg-[var(--rose-violet)] !text-white'}`}
								onClick={() => handleSelect(selectedCategory === category?.catSlug ? null : category?.catSlug)}>
								<span className='text-center text-nowrap text-xs'>{category?.categoryName || category?.pro_cate_name}</span>
							</div>
						);
					})}
				</div>
			)}
		</div>
	);
};

export default Tags;
